<template>
    <transition name="slide-fade">
        <div class="modal ff-reg" :class="{ 'open': open }" v-if="open">
            <div class="modal-content mx-auto max-w-md px-5">
                <div class="bg-white w-full rounded-40 py-5 px-4 text-a-gray-666666">
                    <div class="text-center ff-bold text-15 mb-7 title" v-html="title"></div>
                    <div class="pb-6">
                        <div class="text-center text-15" v-html="message"></div>
                        <template v-if="hasErrorCode">
                            <div class="mt-4 text-normal text-center text-15">
                                Error {{ errCode }}
                            </div>
                        </template>
                    </div>
                    <div class="flex flex-col gap-6">
                        <template v-if="type == 'bzbs'">
                            <button type="button"
                                class="w-full bg-a-gray-333333 text-white text-15 text-semi rounded-full outline-none appearance-none h-16"
                                @click="clickOk('try')">
                                {{ lbl.buttons.tryAgain }}
                            </button>
                            <button type="button"
                                class="w-full text-a-gray-333333 text-15 text-normal outline-none appearance-none capitalize"
                                @click="clickOk('')">
                                {{ lbl.base_button.cancel }}
                            </button>
                        </template>
                        <template v-else>
                            <button type="button"
                                class="w-full bg-white text-a-gray-333333 border border-a-gray-333333 rounded-full h-16 text-normal capitalize"
                                @click="clickOk()">
                                {{ btnOk }}
                            </button>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import { inject } from "vue";
import Util from "@/helper/Utility.js";
//import Button from '@/components/Button/Button.vue';
/**
 * @property {AlertModalController} controller (required) /components/Modal/Controller/AlertModalController.js
 * @property {String} modalId (reqquired)
 */
export default {
    name: "AlertModal",
    components: {
        // Button,
    },
    props: {
        // busModal: Object,
        controller: Object,
        modalId: String,
    },
    data: function () {
        return {
            theme: '',
            title: '',
            message: '',
            btnOk: '',
            tag: '',
            type: '',
            open: false,
            busModal: null,
            errCode: '',
        };
    },
    computed: {
        hasErrorCode: function () {
            return !Util.isEmptyStr(this.errCode)
        }
    },
    setup: function () {
        const localeStore = inject("LocaleStore")

        return {
            lbl: localeStore.lbl
        }
    },
    created: function () {
        this.busModal = this.controller.busModal;
    },
    mounted: function () {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    methods: {
        onModalHidden: function () {
            this.controller.sendCallbackHidden({ tag: this.tag });
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk({ tag: this.tag });
        },
        show: function (config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;
            this.tag = config.tag;
            this.type = config.type;
            if (Util.isEmptyStr(config.btnOk)) {
                this.btnOk = this.lbl.base_button.ok;
            }

            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function () {
            document.body.classList.remove('not-scroll');
            this.open = false;

            this.$nextTick(() => {
                this.onModalHidden()
            })
        },
    },
}
</script>
<style lang="scss" scoped>
@import "@/module/YesCoin/style/base.scss";
@import "@/style/modal.scss";

.modal {
    @extend %modal;

    font-family: $ff-reg;

    .modal-content {
        width: 100%;

        .title {
            font-family: $ff-bold;
        }
    }
}
</style>
